import PropTypes from "prop-types"
import React from "react"

import InlineNotice from "src/components/InlineNotice"

// Shared warning shown on any job-template surface that carries soft-deleted
// items. It reports how many rather than naming them — the line-item table
// below badges each inactive row, so listing names here would be redundant and
// would not scale to many / long names. The "Manage items" catalog link opens
// in a new tab so it never discards in-progress work in the surrounding form.
const InactiveProductsNotice = ({
  count,
  contextLabel,
  resolutionTail,
  canReactivate,
  marinaSlug,
  className,
}) => (
  <InlineNotice
    variant="warning"
    icon="fa-circle-exclamation"
    iconStyle="solid"
    className={className}
  >
    {count === 1 ? "1 item" : `${count} items`} on this {contextLabel}{" "}
    {count === 1 ? "is" : "are"} no longer active. Reactivate or remove{" "}
    {count === 1 ? "it" : "them"} {resolutionTail}
    {canReactivate && (
      <>
        {" "}
        <a
          className="font-semibold underline"
          href={`/manage/${marinaSlug}/items`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Manage items
        </a>
      </>
    )}
  </InlineNotice>
)

InactiveProductsNotice.propTypes = {
  count: PropTypes.number.isRequired,
  // e.g. "job" or "template" — completes "N items on this <contextLabel>".
  contextLabel: PropTypes.string.isRequired,
  // e.g. "before adding this job." or "from this template."
  resolutionTail: PropTypes.string.isRequired,
  canReactivate: PropTypes.bool,
  marinaSlug: PropTypes.string.isRequired,
  className: PropTypes.string,
}

export default InactiveProductsNotice
